import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { DriverUserCredential } from "../models/driver-user-credential.model";
import { firstValueFrom, Subject, takeUntil } from "rxjs";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DriverUserCredentialService {
  private http: HttpClient = inject(HttpClient);

  getUserCredentialsAsync(driverId: number, cancellation: Subject<void>): Promise<DriverUserCredential> {
    return firstValueFrom(this.http.get<DriverUserCredential>(`${environment.apiEndpoint}/driverusercredential/${driverId}`).pipe(takeUntil(cancellation)));
  }

  generateUserCredentialsAsync(driverId: number, cancellation: Subject<void>): Promise<DriverUserCredential> {
    return firstValueFrom(this.http.post<DriverUserCredential>(`${environment.apiEndpoint}/driverusercredential/${driverId}/generate`, null).pipe(takeUntil(cancellation)));
  }

  resetUserPasswordAsync(driverId: number, cancellation: Subject<void>): Promise<DriverUserCredential> {
    return firstValueFrom(this.http.post<DriverUserCredential>(`${environment.apiEndpoint}/driverusercredential/${driverId}/reset-password`, null).pipe(takeUntil(cancellation)));
  }
}